module.exports = __webpack_public_path__ + "0abdd8e21cfce07c5144f9667e3dcd15.png";